// extracted by mini-css-extract-plugin
export default {"paginationBox":"style_paginationBox__Ryw0Z","on":"style_on__UjBvo"};